import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "waybill-request-for-payment-modal__container"
}
const _hoisted_2 = { class: "container__title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "container__subtitle" }, "За что выплата?", -1)
const _hoisted_4 = { class: "container__radio-options" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3.5 h-3.5",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M15 18H9" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "17",
    cy: "18",
    r: "2"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "7",
    cy: "18",
    r: "2"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3.5 w-3.5",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3.5 w-3.5",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m3 17 2 2 4-4" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m3 7 2 2 4-4" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M13 6h8" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M13 12h8" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M13 18h8" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3.5 w-3.5",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 20h9" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z" })
], -1)
const _hoisted_9 = { class: "container__total" }
const _hoisted_10 = { class: "total__container" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "total__label" }, "К выплате:", -1)
const _hoisted_12 = { class: "total__price" }
const _hoisted_13 = { class: "container__payment" }
const _hoisted_14 = { class: "payment__field" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "field__label" }, "Банк", -1)
const _hoisted_16 = { class: "payment__field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "field__label" }, "Тип перевода", -1)
const _hoisted_18 = { class: "field__row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3.5 w-3.5",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3.5 w-3.5",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "20",
    height: "14",
    x: "2",
    y: "5",
    rx: "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "2",
    x2: "22",
    y1: "10",
    y2: "10"
  })
], -1)
const _hoisted_21 = { class: "payment__field" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "field__label" }, "ФИО получателя", -1)
const _hoisted_23 = {
  key: 0,
  class: "payment__field"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "field__label" }, "Номер телефона", -1)
const _hoisted_25 = {
  key: 1,
  class: "payment__field"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "field__label" }, "Номер карты", -1)
const _hoisted_27 = { class: "container__actions" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M18 6 6 18" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m6 6 12 12" })
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m21.854 2.147-10.94 10.939" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_option = _resolveComponent("radio-option")!
  const _component_bs_field = _resolveComponent("bs-field")!
  const _component_bs_divider = _resolveComponent("bs-divider")!
  const _component_bs_select = _resolveComponent("bs-select")!
  const _component_bs_button = _resolveComponent("bs-button")!
  const _component_bs_modal = _resolveComponent("bs-modal")!

  return (_openBlock(), _createBlock(_component_bs_modal, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.onUpdateModelValue
  }, {
    default: _withCtx(() => [
      (_ctx.waybill)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, "Запрос на выплату — " + _toDisplayString(_ctx.waybill.codeOneC), 1),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_radio_option, {
                selected: _ctx.state.paymentSourceId === 10,
                price: _ctx.waybill.ndsTotalAmount,
                disabled: _ctx.state.isLoading,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSelectPaymentSource(10)))
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" За перевозку ")
                ]),
                _: 1
              }, 8, ["selected", "price", "disabled"]),
              _createVNode(_component_radio_option, {
                selected: _ctx.state.paymentSourceId === 11,
                disabled: !Number(_ctx.waybill.additionalServicesTotalAmount) || _ctx.state.isLoading,
                price: Number(_ctx.waybill.additionalServicesTotalAmount),
                "is-price-orange": "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelectPaymentSource(11)))
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createTextVNode(" Доп. услуги ")
                ]),
                _: 1
              }, 8, ["selected", "disabled", "price"]),
              _createVNode(_component_radio_option, {
                selected: _ctx.state.paymentSourceId === 12,
                price: Number(_ctx.total),
                disabled: _ctx.state.isLoading,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelectPaymentSource(12)))
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createTextVNode(" Все ")
                ]),
                _: 1
              }, 8, ["selected", "price", "disabled"]),
              _createVNode(_component_radio_option, {
                selected: _ctx.state.paymentSourceId === 13,
                disabled: _ctx.state.isLoading,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSelectPaymentSource(13)))
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" Прочее ")
                ]),
                _: 1
              }, 8, ["selected", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.state.paymentSourceId === 13)
                ? (_openBlock(), _createBlock(_component_bs_field, {
                    key: 0,
                    placeholder: "Укажите свою сумму",
                    modelValue: _ctx.state.totalAmount,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.totalAmount) = $event)),
                    disabled: _ctx.state.isLoading,
                    mask: _ctx.PRICE_MASK,
                    invalid: _ctx.state_form$.totalAmount.$error,
                    "validation-errors": _ctx.state_form$.totalAmount.$errors
                  }, null, 8, ["modelValue", "disabled", "mask", "invalid", "validation-errors"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatPriceToTenge(_ctx.totalValue)), 1)
              ])
            ]),
            _createVNode(_component_bs_divider, {
              horizontal: "",
              style: {"margin":"1rem 0"}
            }),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_bs_select, {
                  placeholder: "Банк",
                  disabled: "",
                  modelValue: _ctx.state.paymentMethodId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.paymentMethodId) = $event)),
                  options: [{ id: 1, name: 'АО Kaspi Bank' }]
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_radio_option, {
                    selected: _ctx.state.transferTypeId === 1,
                    disabled: _ctx.state.isLoading,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSelectTransferTypeId(1)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19,
                      _createTextVNode(" По номеру ")
                    ]),
                    _: 1
                  }, 8, ["selected", "disabled"]),
                  _createVNode(_component_radio_option, {
                    selected: _ctx.state.transferTypeId === 2,
                    disabled: _ctx.state.isLoading,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSelectTransferTypeId(2)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20,
                      _createTextVNode(" По карте ")
                    ]),
                    _: 1
                  }, 8, ["selected", "disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_bs_field, {
                  placeholder: "Введите ФИО получателя",
                  modelValue: _ctx.state.receiverFullName,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.receiverFullName) = $event)),
                  disabled: _ctx.state.isLoading,
                  invalid: _ctx.state_form$.receiverFullName.$error,
                  "validation-errors": _ctx.state_form$.receiverFullName.$errors
                }, null, 8, ["modelValue", "disabled", "invalid", "validation-errors"])
              ]),
              (_ctx.state.transferTypeId === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_bs_field, {
                      placeholder: "+7 (707) 123 45 67",
                      modelValue: _ctx.state.phoneNumber,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.phoneNumber) = $event)),
                      disabled: _ctx.state.isLoading,
                      mask: _ctx.PHONE_MASK,
                      invalid: _ctx.state_form$.phoneNumber.$error,
                      "validation-errors": _ctx.state_form$.phoneNumber.$errors
                    }, null, 8, ["modelValue", "disabled", "mask", "invalid", "validation-errors"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_bs_field, {
                      placeholder: "0000 0000 0000 0000",
                      modelValue: _ctx.state.cardNumber,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.cardNumber) = $event)),
                      disabled: _ctx.state.isLoading,
                      mask: _ctx.CARD_NUMBER_MASK,
                      invalid: _ctx.state_form$.cardNumber.$error,
                      "validation-errors": _ctx.state_form$.cardNumber.$errors
                    }, null, 8, ["modelValue", "disabled", "mask", "invalid", "validation-errors"])
                  ]))
            ]),
            _createVNode(_component_bs_divider, {
              horizontal: "",
              style: {"margin":"1rem 0"}
            }),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_bs_button, {
                type: "button",
                size: "big",
                disabled: _ctx.state.isLoading,
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onUpdateModelValue(false)))
              }, {
                default: _withCtx(() => [
                  _hoisted_28,
                  _createTextVNode(" Отмена ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_bs_button, {
                type: "button",
                color: "royal-blue",
                size: "big",
                disabled: _ctx.state.isLoading,
                onClick: _ctx.onSubmit
              }, {
                default: _withCtx(() => [
                  _hoisted_29,
                  _createTextVNode(" Отправить ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}